import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
// import { mockAndDevelopment } from './app.config';
import {AuthProvider} from './contexts/authentication/AuthProvider';
import { ColorModeProvider } from './contexts/theme/ColorModeProvider';
import './main.css';

// if (mockAndDevelopment()) {
//   const { worker } = await import('./__mock__/msw/browser');
//   await worker.start({
//     waitUntilReady: true,
//     onUnhandledRequest: 'bypass',
//   });
// }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ColorModeProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
  </ColorModeProvider>
);
